import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetJobCostSummaryQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
}>;


export type GetJobCostSummaryQuery = { __typename?: 'Query', jobCostSummary: { __typename?: 'JobCostSummary', materialBudget: number, materialActual: number, materialVariance: number, materialHasCostRecords: boolean, supplierRoyaltyBudget: number, supplierRoyaltyActual?: number | null, supplierRoyaltyCoverage: Types.SupplierRoyaltyCoverage, laborBudget: number, laborActual: number, laborVariance: number, laborHasCostRecords: boolean, overheadBudget: number, overheadActual: number, overheadVariance: number, overheadHasCostRecords: boolean, additionalBudget: number, additionalActual?: number | null, totalBudget: number, totalActual: number, totalVariance: number, totalHasCostRecords: boolean, effectiveCostPerUnit?: number | null, quantityCompleted: number, quantityTarget: number, hasEstimatedCosts: boolean, isComplete: boolean, missingData: Array<{ __typename?: 'MissingDataFinding', key: string, code: Types.MissingDataCode, subject: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null }, fixAt: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null } }> } };

export type GetLotCostSummaryQueryVariables = Types.Exact<{
  lotId: Types.Scalars['String']['input'];
}>;


export type GetLotCostSummaryQuery = { __typename?: 'Query', lotCostSummary: { __typename?: 'JobCostSummary', materialBudget: number, materialActual: number, materialVariance: number, materialHasCostRecords: boolean, supplierRoyaltyBudget: number, supplierRoyaltyActual?: number | null, supplierRoyaltyCoverage: Types.SupplierRoyaltyCoverage, laborBudget: number, laborActual: number, laborVariance: number, laborHasCostRecords: boolean, overheadBudget: number, overheadActual: number, overheadVariance: number, overheadHasCostRecords: boolean, additionalBudget: number, additionalActual?: number | null, totalBudget: number, totalActual: number, totalVariance: number, totalHasCostRecords: boolean, effectiveCostPerUnit?: number | null, quantityCompleted: number, quantityTarget: number, hasEstimatedCosts: boolean, isComplete: boolean, missingData: Array<{ __typename?: 'MissingDataFinding', key: string, code: Types.MissingDataCode, subject: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null }, fixAt: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null } }> } };

export type GetJobCostBreakdownQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  costCategory: Types.CostCategory;
}>;


export type GetJobCostBreakdownQuery = { __typename?: 'Query', jobCostBreakdown: Array<{ __typename?: 'CostCategoryBreakdown', subcategory?: string | null, totalCost: number, totalQuantity: number, unitCost?: number | null, unit?: string | null, headcount?: number | null, recordCount: number }> };

export type GetLotCostBreakdownQueryVariables = Types.Exact<{
  lotId: Types.Scalars['String']['input'];
  costCategory: Types.CostCategory;
}>;


export type GetLotCostBreakdownQuery = { __typename?: 'Query', lotCostBreakdown: Array<{ __typename?: 'CostCategoryBreakdown', subcategory?: string | null, totalCost: number, totalQuantity: number, unitCost?: number | null, unit?: string | null, headcount?: number | null, recordCount: number }> };

export type JobCostSummaryFieldsFragment = { __typename?: 'JobCostSummary', materialBudget: number, materialActual: number, materialVariance: number, materialHasCostRecords: boolean, supplierRoyaltyBudget: number, supplierRoyaltyActual?: number | null, supplierRoyaltyCoverage: Types.SupplierRoyaltyCoverage, laborBudget: number, laborActual: number, laborVariance: number, laborHasCostRecords: boolean, overheadBudget: number, overheadActual: number, overheadVariance: number, overheadHasCostRecords: boolean, additionalBudget: number, additionalActual?: number | null, totalBudget: number, totalActual: number, totalVariance: number, totalHasCostRecords: boolean, effectiveCostPerUnit?: number | null, quantityCompleted: number, quantityTarget: number, hasEstimatedCosts: boolean, isComplete: boolean, missingData: Array<{ __typename?: 'MissingDataFinding', key: string, code: Types.MissingDataCode, subject: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null }, fixAt: { __typename?: 'RecordRef', entityType: Types.MissingDataEntityType, id: string, label: string, parentId?: string | null } }> };

export type CostCategoryBreakdownFieldsFragment = { __typename?: 'CostCategoryBreakdown', subcategory?: string | null, totalCost: number, totalQuantity: number, unitCost?: number | null, unit?: string | null, headcount?: number | null, recordCount: number };

export type GetJobCostRecordsQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  costCategory?: Types.InputMaybe<Types.CostCategory>;
  sourceType?: Types.InputMaybe<Types.CostSourceType>;
}>;


export type GetJobCostRecordsQuery = { __typename?: 'Query', jobCostRecords: Array<{ __typename?: 'JobCostRecordDocument', recordId: string, jobId: string, costCategory: Types.CostCategory, amount: number, unitCost?: number | null, quantity?: number | null, unit?: string | null, sourceType: Types.CostSourceType, subcategory?: string | null, description?: string | null, recordedDate: Types.TDateISO, isEstimated: boolean, isReversal: boolean }> };

export type GetLotCostRecordsQueryVariables = Types.Exact<{
  lotId: Types.Scalars['String']['input'];
  costCategory?: Types.InputMaybe<Types.CostCategory>;
}>;


export type GetLotCostRecordsQuery = { __typename?: 'Query', lotCostRecords: Array<{ __typename?: 'JobCostRecordDocument', recordId: string, jobId: string, costCategory: Types.CostCategory, amount: number, unitCost?: number | null, quantity?: number | null, unit?: string | null, sourceType: Types.CostSourceType, subcategory?: string | null, description?: string | null, recordedDate: Types.TDateISO, isEstimated: boolean, isReversal: boolean }> };

export type GetJobCostTimelineQueryVariables = Types.Exact<{
  jobId: Types.Scalars['String']['input'];
  weeks: Types.Scalars['Int']['input'];
}>;


export type GetJobCostTimelineQuery = { __typename?: 'Query', jobCostTimeline: Array<{ __typename?: 'CostTimelineEntry', weekLabel: string, weekStart: Types.TDateISO, laborCost: number, materialCost: number, overheadCost: number }> };

export type GetLotCostTimelineQueryVariables = Types.Exact<{
  lotId: Types.Scalars['String']['input'];
  weeks: Types.Scalars['Int']['input'];
}>;


export type GetLotCostTimelineQuery = { __typename?: 'Query', lotCostTimeline: Array<{ __typename?: 'CostTimelineEntry', weekLabel: string, weekStart: Types.TDateISO, laborCost: number, materialCost: number, overheadCost: number }> };

export type JobCostRecordFieldsFragment = { __typename?: 'JobCostRecordDocument', recordId: string, jobId: string, costCategory: Types.CostCategory, amount: number, unitCost?: number | null, quantity?: number | null, unit?: string | null, sourceType: Types.CostSourceType, subcategory?: string | null, description?: string | null, recordedDate: Types.TDateISO, isEstimated: boolean, isReversal: boolean };

export type CostTimelineEntryFieldsFragment = { __typename?: 'CostTimelineEntry', weekLabel: string, weekStart: Types.TDateISO, laborCost: number, materialCost: number, overheadCost: number };

export type GetJobCostSubcategoriesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetJobCostSubcategoriesQuery = { __typename?: 'Query', jobCostSubcategories: Array<string> };

export const JobCostSummaryFieldsFragmentDoc = new TypedDocumentString(`
    fragment JobCostSummaryFields on JobCostSummary {
  materialBudget
  materialActual
  materialVariance
  materialHasCostRecords
  supplierRoyaltyBudget
  supplierRoyaltyActual
  supplierRoyaltyCoverage
  laborBudget
  laborActual
  laborVariance
  laborHasCostRecords
  overheadBudget
  overheadActual
  overheadVariance
  overheadHasCostRecords
  additionalBudget
  additionalActual
  totalBudget
  totalActual
  totalVariance
  totalHasCostRecords
  effectiveCostPerUnit
  quantityCompleted
  quantityTarget
  hasEstimatedCosts
  isComplete
  missingData {
    ...MissingDataFinding
  }
}
    fragment MissingDataFinding on MissingDataFinding {
  key
  code
  subject {
    ...MissingDataRecordRef
  }
  fixAt {
    ...MissingDataRecordRef
  }
}
fragment MissingDataRecordRef on RecordRef {
  entityType
  id
  label
  parentId
}`, {"fragmentName":"JobCostSummaryFields"});
export const CostCategoryBreakdownFieldsFragmentDoc = new TypedDocumentString(`
    fragment CostCategoryBreakdownFields on CostCategoryBreakdown {
  subcategory
  totalCost
  totalQuantity
  unitCost
  unit
  headcount
  recordCount
}
    `, {"fragmentName":"CostCategoryBreakdownFields"});
export const JobCostRecordFieldsFragmentDoc = new TypedDocumentString(`
    fragment JobCostRecordFields on JobCostRecordDocument {
  recordId
  jobId
  costCategory
  amount
  unitCost
  quantity
  unit
  sourceType
  subcategory
  description
  recordedDate
  isEstimated
  isReversal
}
    `, {"fragmentName":"JobCostRecordFields"});
export const CostTimelineEntryFieldsFragmentDoc = new TypedDocumentString(`
    fragment CostTimelineEntryFields on CostTimelineEntry {
  weekLabel
  weekStart
  laborCost
  materialCost
  overheadCost
}
    `, {"fragmentName":"CostTimelineEntryFields"});
export const GetJobCostSummaryDocument = new TypedDocumentString(`
    query GetJobCostSummary($jobId: String!) {
  jobCostSummary(jobId: $jobId) {
    ...JobCostSummaryFields
  }
}
    fragment JobCostSummaryFields on JobCostSummary {
  materialBudget
  materialActual
  materialVariance
  materialHasCostRecords
  supplierRoyaltyBudget
  supplierRoyaltyActual
  supplierRoyaltyCoverage
  laborBudget
  laborActual
  laborVariance
  laborHasCostRecords
  overheadBudget
  overheadActual
  overheadVariance
  overheadHasCostRecords
  additionalBudget
  additionalActual
  totalBudget
  totalActual
  totalVariance
  totalHasCostRecords
  effectiveCostPerUnit
  quantityCompleted
  quantityTarget
  hasEstimatedCosts
  isComplete
  missingData {
    ...MissingDataFinding
  }
}
fragment MissingDataFinding on MissingDataFinding {
  key
  code
  subject {
    ...MissingDataRecordRef
  }
  fixAt {
    ...MissingDataRecordRef
  }
}
fragment MissingDataRecordRef on RecordRef {
  entityType
  id
  label
  parentId
}`);
export const GetLotCostSummaryDocument = new TypedDocumentString(`
    query GetLotCostSummary($lotId: String!) {
  lotCostSummary(lotId: $lotId) {
    ...JobCostSummaryFields
  }
}
    fragment JobCostSummaryFields on JobCostSummary {
  materialBudget
  materialActual
  materialVariance
  materialHasCostRecords
  supplierRoyaltyBudget
  supplierRoyaltyActual
  supplierRoyaltyCoverage
  laborBudget
  laborActual
  laborVariance
  laborHasCostRecords
  overheadBudget
  overheadActual
  overheadVariance
  overheadHasCostRecords
  additionalBudget
  additionalActual
  totalBudget
  totalActual
  totalVariance
  totalHasCostRecords
  effectiveCostPerUnit
  quantityCompleted
  quantityTarget
  hasEstimatedCosts
  isComplete
  missingData {
    ...MissingDataFinding
  }
}
fragment MissingDataFinding on MissingDataFinding {
  key
  code
  subject {
    ...MissingDataRecordRef
  }
  fixAt {
    ...MissingDataRecordRef
  }
}
fragment MissingDataRecordRef on RecordRef {
  entityType
  id
  label
  parentId
}`);
export const GetJobCostBreakdownDocument = new TypedDocumentString(`
    query GetJobCostBreakdown($jobId: String!, $costCategory: CostCategory!) {
  jobCostBreakdown(jobId: $jobId, costCategory: $costCategory) {
    ...CostCategoryBreakdownFields
  }
}
    fragment CostCategoryBreakdownFields on CostCategoryBreakdown {
  subcategory
  totalCost
  totalQuantity
  unitCost
  unit
  headcount
  recordCount
}`);
export const GetLotCostBreakdownDocument = new TypedDocumentString(`
    query GetLotCostBreakdown($lotId: String!, $costCategory: CostCategory!) {
  lotCostBreakdown(lotId: $lotId, costCategory: $costCategory) {
    ...CostCategoryBreakdownFields
  }
}
    fragment CostCategoryBreakdownFields on CostCategoryBreakdown {
  subcategory
  totalCost
  totalQuantity
  unitCost
  unit
  headcount
  recordCount
}`);
export const GetJobCostRecordsDocument = new TypedDocumentString(`
    query GetJobCostRecords($jobId: String!, $costCategory: CostCategory, $sourceType: CostSourceType) {
  jobCostRecords(
    jobId: $jobId
    costCategory: $costCategory
    sourceType: $sourceType
  ) {
    ...JobCostRecordFields
  }
}
    fragment JobCostRecordFields on JobCostRecordDocument {
  recordId
  jobId
  costCategory
  amount
  unitCost
  quantity
  unit
  sourceType
  subcategory
  description
  recordedDate
  isEstimated
  isReversal
}`);
export const GetLotCostRecordsDocument = new TypedDocumentString(`
    query GetLotCostRecords($lotId: String!, $costCategory: CostCategory) {
  lotCostRecords(lotId: $lotId, costCategory: $costCategory) {
    ...JobCostRecordFields
  }
}
    fragment JobCostRecordFields on JobCostRecordDocument {
  recordId
  jobId
  costCategory
  amount
  unitCost
  quantity
  unit
  sourceType
  subcategory
  description
  recordedDate
  isEstimated
  isReversal
}`);
export const GetJobCostTimelineDocument = new TypedDocumentString(`
    query GetJobCostTimeline($jobId: String!, $weeks: Int!) {
  jobCostTimeline(jobId: $jobId, weeks: $weeks) {
    ...CostTimelineEntryFields
  }
}
    fragment CostTimelineEntryFields on CostTimelineEntry {
  weekLabel
  weekStart
  laborCost
  materialCost
  overheadCost
}`);
export const GetLotCostTimelineDocument = new TypedDocumentString(`
    query GetLotCostTimeline($lotId: String!, $weeks: Int!) {
  lotCostTimeline(lotId: $lotId, weeks: $weeks) {
    ...CostTimelineEntryFields
  }
}
    fragment CostTimelineEntryFields on CostTimelineEntry {
  weekLabel
  weekStart
  laborCost
  materialCost
  overheadCost
}`);
export const GetJobCostSubcategoriesDocument = new TypedDocumentString(`
    query GetJobCostSubcategories {
  jobCostSubcategories
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetJobCostSummary: build.query<GetJobCostSummaryQuery, GetJobCostSummaryQueryVariables>({
      query: (variables) => ({ document: GetJobCostSummaryDocument, variables })
    }),
    GetLotCostSummary: build.query<GetLotCostSummaryQuery, GetLotCostSummaryQueryVariables>({
      query: (variables) => ({ document: GetLotCostSummaryDocument, variables })
    }),
    GetJobCostBreakdown: build.query<GetJobCostBreakdownQuery, GetJobCostBreakdownQueryVariables>({
      query: (variables) => ({ document: GetJobCostBreakdownDocument, variables })
    }),
    GetLotCostBreakdown: build.query<GetLotCostBreakdownQuery, GetLotCostBreakdownQueryVariables>({
      query: (variables) => ({ document: GetLotCostBreakdownDocument, variables })
    }),
    GetJobCostRecords: build.query<GetJobCostRecordsQuery, GetJobCostRecordsQueryVariables>({
      query: (variables) => ({ document: GetJobCostRecordsDocument, variables })
    }),
    GetLotCostRecords: build.query<GetLotCostRecordsQuery, GetLotCostRecordsQueryVariables>({
      query: (variables) => ({ document: GetLotCostRecordsDocument, variables })
    }),
    GetJobCostTimeline: build.query<GetJobCostTimelineQuery, GetJobCostTimelineQueryVariables>({
      query: (variables) => ({ document: GetJobCostTimelineDocument, variables })
    }),
    GetLotCostTimeline: build.query<GetLotCostTimelineQuery, GetLotCostTimelineQueryVariables>({
      query: (variables) => ({ document: GetLotCostTimelineDocument, variables })
    }),
    GetJobCostSubcategories: build.query<GetJobCostSubcategoriesQuery, GetJobCostSubcategoriesQueryVariables | void>({
      query: (variables) => ({ document: GetJobCostSubcategoriesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetJobCostSummaryQuery, useLazyGetJobCostSummaryQuery, useGetLotCostSummaryQuery, useLazyGetLotCostSummaryQuery, useGetJobCostBreakdownQuery, useLazyGetJobCostBreakdownQuery, useGetLotCostBreakdownQuery, useLazyGetLotCostBreakdownQuery, useGetJobCostRecordsQuery, useLazyGetJobCostRecordsQuery, useGetLotCostRecordsQuery, useLazyGetLotCostRecordsQuery, useGetJobCostTimelineQuery, useLazyGetJobCostTimelineQuery, useGetLotCostTimelineQuery, useLazyGetLotCostTimelineQuery, useGetJobCostSubcategoriesQuery, useLazyGetJobCostSubcategoriesQuery } = injectedRtkApi;
